import { render, staticRenderFns } from "./user-followup-4.vue?vue&type=template&id=fef2fafa&scoped=true"
import script from "./user-followup-4.vue?vue&type=script&lang=js"
export * from "./user-followup-4.vue?vue&type=script&lang=js"
import style0 from "./user-followup-4.vue?vue&type=style&index=0&id=fef2fafa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef2fafa",
  null
  
)

export default component.exports